import { render, staticRenderFns } from "./TelaDeModalidadesDeVenda.vue?vue&type=template&id=49c3fe2e&"
import script from "./TelaDeModalidadesDeVenda.vue?vue&type=script&lang=ts&"
export * from "./TelaDeModalidadesDeVenda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
